import { render, staticRenderFns } from "./GruposDeProdutos.vue?vue&type=template&id=521da2b4"
import script from "./GruposDeProdutos.vue?vue&type=script&lang=js"
export * from "./GruposDeProdutos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports